/**
 * Public Blog Manager
 * Blog listesi ve detay sayfası için JavaScript yöneticisi
 */

(function () {
  "use strict";

  const BlogPublic = {
    /**
     * AJAX content loader
     * Verilen URL'den içeriği çeker ve content-area'yı günceller
     */
    loadContent: function (url, pushState = true) {
      const contentArea = document.querySelector(".content-area");
      if (contentArea) {
        contentArea.style.opacity = "0.5";
        contentArea.style.pointerEvents = "none";
      }

      // URL nesnesi oluştur (string veya URL object gelebilir)
      const fetchUrl = new URL(url, window.location.origin);

      fetch(fetchUrl.toString(), {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((response) => {
          if (!response.ok) throw new Error("Network response was not ok");
          return response.text();
        })
        .then((html) => {
          if (contentArea) {
            contentArea.innerHTML = html;
            contentArea.style.opacity = "1";
            contentArea.style.pointerEvents = "auto";

            if (pushState) {
              window.history.pushState({}, "", fetchUrl.toString());
            }

            // İçerik güncellendikten sonra yukarı kaydır
            setTimeout(() => {
              BlogPublic.scrollToTop();
            }, 50);
          }
        })
        .catch((error) => {
          console.error("İçerik yüklenirken hata oluştu:", error);
          if (contentArea) {
            contentArea.style.opacity = "1";
            contentArea.style.pointerEvents = "auto";
          }
          // Hata durumunda kullanıcıyı bilgilendir veya tam sayfa yönlendirmesi yap
          // window.location.href = url; // Fallback olarak yönlendirme yapılabilir
        });
    },

    /**
     * AJAX pagination handler (Blog listesi)
     * Event delegation kullanarak dinamik içerik için çalışır
     */
    initPagination: function () {
      const contentArea = document.querySelector(".content-area");
      if (!contentArea) return;

      // Mevcut listener'ı temizle
      contentArea.removeEventListener("click", this._paginationHandler);

      this._paginationHandler = function (e) {
        const target = e.target.closest(".page-item");
        if (!target) return;

        e.preventDefault();

        const page = target.dataset.page;
        if (!page) return;

        const url = new URL(window.location.href);
        url.searchParams.set("page", page);

        BlogPublic.loadContent(url);
      };

      contentArea.addEventListener("click", this._paginationHandler);
    },

    /**
     * Sayfayı en üste kaydır
     */
    scrollToTop: function () {
      // Ana scroll container (.snap-container) üzerinden işlem yapıyoruz
      const scrollContainer = document.querySelector(".snap-container");
      const blogsSection = document.querySelector("#blogs") || document.querySelector("#blog-list");

      if (scrollContainer && blogsSection) {
        const sectionTop = blogsSection.offsetTop;
        const headerOffset = 100;

        scrollContainer.scrollTo({
          top: sectionTop - headerOffset,
          behavior: "smooth",
        });
      } else {
        if (scrollContainer) {
          scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      }
    },

    /**
     * Sidebar filtreleme (Search ve Category)
     */
    initFilters: function () {
      // 1. Arama İşlemleri
      // 1. Arama İşlemleri
      const searchForm = document.getElementById("searchForm");
      if (searchForm) {
        // Remove existing listeners by cloning (simple way to ensure no duplicates)
        const newSearchForm = searchForm.cloneNode(true);
        searchForm.parentNode.replaceChild(newSearchForm, searchForm);

        newSearchForm.addEventListener("submit", function (e) {
          e.preventDefault();

          const searchInput = newSearchForm.querySelector('input[name="searchTerm"]');
          const searchTerm = searchInput ? searchInput.value.trim() : "";

          let url;
          if (searchTerm) {
            url = `/Blog/Ara?searchTerm=${encodeURIComponent(searchTerm)}`;
          } else {
            // Eğer boş arama ise ana sayfaya dön
            url = `/Bloglar`;
          }

          BlogPublic.loadContent(url);
        });
      }

      // 2. Kategori Linkleri
      const categoryWidget = document.querySelector(".category-widget");
      if (categoryWidget) {
        const categoryList = categoryWidget.querySelector(".category-list");
        if (categoryList) {
          // Event delegation
          categoryList.addEventListener("click", function (e) {
            const link = e.target.closest("a");
            if (!link) return;

            // Eğer dış link değilse (internal routing)
            const href = link.getAttribute("href");
            if (href && (href.startsWith("/") || href.startsWith(window.location.origin))) {
              e.preventDefault();

              // Aktif sınıfını güncelle
              const allItems = categoryList.querySelectorAll("li");
              allItems.forEach((item) => item.classList.remove("active"));
              link.parentElement.classList.add("active");

              BlogPublic.loadContent(href);
            }
          });
        }
      }
    },

    /**
     * Browser Back/Forward butonlarını dinle
     */
    initHistoryListener: function () {
      window.addEventListener("popstate", function (e) {
        // Sayfa değiştiğinde içeriği yeniden yükle (AJAX ile)
        BlogPublic.loadContent(window.location.href, false);
      });
    },

    /**
     * Blog Detay Sayfası - Paylaşım Modal
     */
    initShareModal: function () {
      const btnShare = document.getElementById("btnShareArticle");
      if (!btnShare) return;

      btnShare.addEventListener("click", function (e) {
        e.preventDefault();
        const currentUrl = encodeURIComponent(window.location.href);
        const title = encodeURIComponent(document.title);

        const fbShare = `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`;
        const twShare = `https://twitter.com/intent/tweet?url=${currentUrl}&text=${title}`;
        const waShare = `https://api.whatsapp.com/send?text=${title} - ${currentUrl}`;
        const inShare = `https://www.linkedin.com/shareArticle?mini=true&url=${currentUrl}&title=${title}`;

        Swal.fire({
          title: "Yazıyı Paylaş",
          html: `
                        <p class="text-center text-sm font-medium text-[var(--text-four)] mb-6 mt-2">Bu içeriği ağınızla veya arkadaşlarınızla anında paylaşın:</p>
                        <div class="grid grid-cols-3 sm:grid-cols-5 gap-3 sm:gap-4 px-1 pb-2 max-w-[340px] sm:max-w-full mx-auto">
                            <button onclick="window.open('${fbShare}', '_blank')" class="group flex flex-col items-center justify-center w-full aspect-square bg-[var(--base-content)] border-2 border-[var(--border-color)] hover:border-[#1877F2] rounded-[1.25rem] transition-all duration-300 gap-2 shadow-sm hover:shadow-[0_8px_16px_-4px_rgba(24,119,242,0.25)] hover:-translate-y-1 relative overflow-hidden focus:outline-none">
                                <div class="absolute inset-0 bg-[#1877F2]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                <i class="bx bxl-facebook text-3xl text-[var(--text-four)] group-hover:text-[#1877F2] group-hover:scale-110 transition-all duration-300 relative z-10"></i>
                                <span class="text-[9px] sm:text-[10px] uppercase tracking-wider font-bold text-[var(--text-second)] group-hover:text-[#1877F2] transition-colors relative z-10">Facebook</span>
                            </button>

                            <button onclick="window.open('${twShare}', '_blank')" class="group flex flex-col items-center justify-center w-full aspect-square bg-[var(--base-content)] border-2 border-[var(--border-color)] hover:border-black dark:hover:border-white rounded-[1.25rem] transition-all duration-300 gap-2 shadow-sm hover:shadow-[0_8px_16px_-4px_rgba(0,0,0,0.15)] dark:hover:shadow-[0_8px_16px_-4px_rgba(255,255,255,0.1)] hover:-translate-y-1 relative overflow-hidden focus:outline-none">
                                <div class="absolute inset-0 bg-black/5 dark:bg-white/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                <i class="bx bxl-twitter text-3xl text-[var(--text-four)] group-hover:text-black dark:group-hover:text-white group-hover:scale-110 transition-all duration-300 relative z-10"></i>
                                <span class="text-[9px] sm:text-[10px] uppercase tracking-wider font-bold text-[var(--text-second)] group-hover:text-black dark:group-hover:text-white transition-colors relative z-10">Twitter</span>
                            </button>

                            <button onclick="window.open('${waShare}', '_blank')" class="group flex flex-col items-center justify-center w-full aspect-square bg-[var(--base-content)] border-2 border-[var(--border-color)] hover:border-[#25D366] rounded-[1.25rem] transition-all duration-300 gap-2 shadow-sm hover:shadow-[0_8px_16px_-4px_rgba(37,211,102,0.25)] hover:-translate-y-1 relative overflow-hidden focus:outline-none">
                                <div class="absolute inset-0 bg-[#25D366]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                <i class="bx bxl-whatsapp text-3xl text-[var(--text-four)] group-hover:text-[#25D366] group-hover:scale-110 transition-all duration-300 relative z-10"></i>
                                <span class="text-[9px] sm:text-[10px] uppercase tracking-wider font-bold text-[var(--text-second)] group-hover:text-[#25D366] transition-colors relative z-10">WhatsApp</span>
                            </button>

                            <button onclick="window.open('${inShare}', '_blank')" class="group flex flex-col items-center justify-center w-full aspect-square bg-[var(--base-content)] border-2 border-[var(--border-color)] hover:border-[#0A66C2] rounded-[1.25rem] transition-all duration-300 gap-2 shadow-sm hover:shadow-[0_8px_16px_-4px_rgba(10,102,194,0.25)] hover:-translate-y-1 relative overflow-hidden focus:outline-none">
                                <div class="absolute inset-0 bg-[#0A66C2]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                <i class="bx bxl-linkedin text-3xl text-[var(--text-four)] group-hover:text-[#0A66C2] group-hover:scale-110 transition-all duration-300 relative z-10"></i>
                                <span class="text-[9px] sm:text-[10px] uppercase tracking-wider font-bold text-[var(--text-second)] group-hover:text-[#0A66C2] transition-colors relative z-10">LinkedIn</span>
                            </button>

                            <button id="btnCopyLinkModal" class="group flex flex-col items-center justify-center w-full aspect-square bg-[var(--base-content)] border-2 border-[var(--border-color)] hover:border-[var(--theme-primary)] rounded-[1.25rem] transition-all duration-300 gap-2 shadow-sm hover:shadow-[0_8px_16px_-4px_color-mix(in_oklab,var(--theme-primary)_30%,transparent)] hover:-translate-y-1 relative overflow-hidden focus:outline-none">
                                <div class="absolute inset-0 bg-[var(--theme-primary)]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                <i class="bx bx-link text-3xl text-[var(--text-four)] group-hover:text-[var(--theme-primary)] group-hover:scale-110 transition-all duration-300 relative z-10"></i>
                                <span class="text-[9px] sm:text-[10px] uppercase tracking-wider font-bold text-[var(--text-second)] group-hover:text-[var(--theme-primary)] transition-colors relative z-10">Kopyala</span>
                            </button>
                        </div>
                    `,
          showCloseButton: true,
          showConfirmButton: false,
          buttonsStyling: false,
          customClass: {
            popup: "swal2-custom-popup !pb-6",
            title: "swal2-custom-title !mb-4",
            htmlContainer: "swal2-custom-html",
          },
          didOpen: () => {
            const btnCopy = Swal.getHtmlContainer().querySelector("#btnCopyLinkModal");
            if (btnCopy) {
              btnCopy.addEventListener("click", () => {
                navigator.clipboard.writeText(window.location.href);
                Swal.fire({
                  icon: "success",
                  title: "Tebrikler!",
                  text: "Yazı bağlantısı başarıyla panoya kopyalandı.",
                  timer: 2000,
                  showConfirmButton: false,
                  customClass: {
                    popup: "swal2-custom-popup",
                    title: "swal2-custom-title",
                    htmlContainer: "swal2-custom-html",
                  },
                });
              });
            }
          },
        });
      });
    },

    /**
     * Initialize all
     */
    init: function () {
      this.initPagination();
      this.initFilters();
      this.initHistoryListener();
      this.initShareModal();
    },
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      BlogPublic.init();
    });
  } else {
    BlogPublic.init();
  }

  window.BlogPublic = BlogPublic;
})();
